/**
 * Convert a desired world-space centre to `step.position`, undoing the renderer's
 * offset convention:
 *   mesh.x = pos.x + treadWidth/2
 *   mesh.z = pos.z + (treadDepth + nose)/2 - nose
 */
export function centerToPosition(
    cx: number,
    cz: number,
    treadWidth: number,
    treadDepth: number,
    noseLength: number
): { x: number; z: number } {
    return {
        x: cx - treadWidth / 2,
        z: cz - (treadDepth + noseLength) / 2 + noseLength,
    };
}
